__turbopack_context__.v({
  "Chevron": "accordion-module__LIEwpW__Chevron",
  "Container": "accordion-module__LIEwpW__Container",
  "Content": "accordion-module__LIEwpW__Content",
  "ContentText": "accordion-module__LIEwpW__ContentText",
  "Header": "accordion-module__LIEwpW__Header",
  "Trigger": "accordion-module__LIEwpW__Trigger",
  "slideDown": "accordion-module__LIEwpW__slideDown",
  "slideUp": "accordion-module__LIEwpW__slideUp",
});
